// @flow

import { animated } from 'react-spring';
import styled from 'styled-components';

export default styled(animated.nav).attrs({ role: 'navigation' })`
  display: flex;
  justify-content: flex-start;
`;
